import { Grid, TablePagination } from '@material-ui/core';
import TableNavigationGoToPage from '../book/TableNavigationGoToPage';
import React from 'react';

const TableNavigation = ({ currentPage, totalPages, onPageChange, totalItens, itensPerPage }) => {
  return (
  <>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TableNavigationGoToPage
          curPage={ currentPage }
          maxPage={ totalPages }
          onPageChange={ async (page) => onPageChange(page)}
        />
      </Grid>
      <Grid item xs={6}>
        <TablePagination
          component='div'
          count={ totalItens ?? 0 }
          onPageChange={ async (event, page) => onPageChange(page + 1)}
          page={ currentPage ? currentPage - 1 : 0 }
          rowsPerPage={ itensPerPage ?? 10 }
          rowsPerPageOptions={ [itensPerPage ?? 1] }
          showFirstButton
          showLastButton
        />
      </Grid>
    </Grid>
  </>
  );
}

export default TableNavigation;
